import BaseModel from '../core/BaseModel';
import UserModel from '@/models/UserModel';

export default class PointHistoryModel extends BaseModel {
  constructor() {
    super(
      {
        name: 'point_history',
        tableName: 'point_history',
        label: 'Point history',
      },
      {
        stt: {
          name: 'stt',
          label: 'No.',
          type: 'Computed',
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },

        id: {
          name: 'id',
          type: 'Uuid',
          label: 'ID',
          primaryKey: true,
          display: false,
        },

        uid: {
          name: 'uid',
          type: 'Uuid',
          label: 'Uid',
          display: false,
        },
        
        user_name_by_key: {
          name: 'user_name_by_key',
          label: 'User',
          type: 'Computed',
          computed: (data) => {
            data.user_name_by_key = '';
          },
          filter: { type: 'input', match: 'contains' },
          class: 'left',
          width: 15,
        },

        user_email_by_key: {
          name: 'user_email_by_key',
          label: 'Email',
          type: 'Computed',
          computed: (data) => {
            data.user_email_by_key = '';
          },
          class: 'left',
          filter: { type: 'input', match: 'contains' },
          width: 15,
        },

        description: {
          name: 'description',
          type: 'String',
          label: 'Description',
          filter: { type: 'input', match: 'contains' },
          class: 'left',
        },

        amount: {
          name: 'amount',
          type: 'Number',
          label: 'Amount',
          class: 'left',
        },

        updated_by: {
          name: 'updated_by',
          type: 'Uuid',
          label: 'Updated By',
          display: false,
        },

        updated_at: {
          name: 'updated_at',
          type: 'String',
          label: 'Updated date',
          width: 15,
          display: false,
        },

        created_by_key: {
          name: 'created_by_key',
          label: 'Created by',
          type: 'Computed',
          models: new UserModel(),
          computed: (data) => {
            data.created_by_key = '';
          },
          class: 'left',
          width: 15,
        },

        created_at: {
          name: 'created_at',
          type: 'String',
          label: 'Created date',
          width: 15,
          class: 'left',
        },

        created_by: {
          name: 'created_by',
          type: 'Uuid',
          label: 'Created By',
          display: false,
        },

        deleted: {
          name: 'deleted',
          type: 'Boolean',
          label: 'Deleted',
          display: false,
        },
      }
    );
  }
}
